import { render, staticRenderFns } from "./DisplayForm.vue?vue&type=template&id=8053b492&scoped=true"
import script from "./DisplayForm.vue?vue&type=script&lang=js"
export * from "./DisplayForm.vue?vue&type=script&lang=js"
import style0 from "./DisplayForm.vue?vue&type=style&index=0&id=8053b492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8053b492",
  null
  
)

export default component.exports